import { makeAutoObservable } from "mobx";

class ModalStore {
	showUpgradeRequiredModal: boolean = false;

	constructor() {
		makeAutoObservable(this);
	}

	setShowUpgradeRequiredModal = (show: boolean) => {
		this.showUpgradeRequiredModal = show;
	}
}
export const modalStore = new ModalStore();
